import { useQueryClient } from '@tanstack/vue-query';

export function useUpdateDatatableRow() {
    const queryClient = useQueryClient();

    function updateDataTableRow(queryKey: any, rowIndex: number, columnId: keyof any, value: any) {
        queryClient.setQueryData<any[]>(queryKey, (old) => {
            if (!old) return old;
            const newData = [...old];
            newData[rowIndex] = { ...newData[rowIndex], [columnId]: value };
            return newData;
        });
    }

    return { updateDataTableRow };
}
